import { call, fork, put, takeEvery } from 'redux-saga/effects';

import { ClarisApiError } from '../domain/error';

import {
  DataSettingsDataResendAction,
  DataSettingsDataResendActionCreators,
  DataSettingsDataResendActionTypes,
} from '../redux/server/dataSettingsDataResend';
import { ApiResend, buildConfig } from '../utils/api';
import { handleErrorSaga } from './errorSaga';

/**
 * 営業データ再送信を実行する
 *
 * 営業データ再送信処理には、バックエンドから共通APIをpostする際にIP制限がかかっているため、特定のIPアドレスからのリクエストのみが許可される仕組みになっている。
 * そのため、営業データ再送信用のAPIは通常のAPIとは別に設定しており、各環境のenvファイルにて環境変数 `REACT_APP_API_RESEND_HOST` を使用して指定される。
 */
function* dataSettingsDataResendSaga(
  apiResend: ApiResend,
  action: DataSettingsDataResendAction
) {
  try {
    const { hallCode, dates } = action.payload;
    yield put(
      DataSettingsDataResendActionCreators.dataSettingsDataResendRequestAction()
    );

    yield call(
      apiResend.post,
      `/settings/dataResend/${hallCode}`,
      { ymdList: dates },
      buildConfig()
    );

    yield put(
      DataSettingsDataResendActionCreators.dataSettingsDataResendSuccessAction()
    );
  } catch (error: unknown) {
    yield put(
      DataSettingsDataResendActionCreators.dataSettingsDataResendFailureAction(
        error as ClarisApiError
      )
    );
    yield fork(handleErrorSaga, error);
  }
}

function* handleDataSettingsDataResendSaga(apiResend: ApiResend) {
  yield takeEvery(
    DataSettingsDataResendActionTypes.DATA_SETTINGS_DATA_RESEND,
    dataSettingsDataResendSaga,
    apiResend
  );
}

export function* dataSettingsDataResendSagas(context: {
  apiResend: ApiResend;
}) {
  yield fork(handleDataSettingsDataResendSaga, context.apiResend);
}
